/*
 * @Descripttion:
 * @version:
 * @Author: lxh3@meitu.com
 * @Date: 2025-05-26 20:03:19
 * @LastEditors: zwh2 zwh2@meitu.com
 * @LastEditTime: 2025-10-17 16:55:14
 */
import {
  createEnvFunctions, createNavigateAgent, createPageAgent, createStatAgent,
  NavigateOptions,
} from '@meitu/catalyze';
import { Config } from './config';
import { PageId, PageInfo, pageMap } from './pageType';
import {
  getNavigateOriginId, getRoboneoSiteDomain, RoboneoSiteDomain,
} from './siteDomain';

export const { getEnv } = createEnvFunctions<Config>({
  envMap: {
    development: {
      ENV: 'development',
      ROBONEO_ORIGIN: '/--roboneo',
      CLIENT_ID: process.env.NEXT_PUBLIC_REBONEO_CLIENT_ID as string,
      ROBONEO_APP_KEY: '16440FE95FA2A86F',
    },
    dev: {
      ENV: 'dev',
      ROBONEO_ORIGIN: 'https://pre.roboneo.com',
      CLIENT_ID: process.env.NEXT_PUBLIC_REBONEO_CLIENT_ID as string,
      ROBONEO_APP_KEY: '16440FE95FA2A86F',
    },
    pre: {
      ENV: 'pre',
      ROBONEO_ORIGIN: 'https://pre.roboneo.com',
      CLIENT_ID: process.env.NEXT_PUBLIC_REBONEO_CLIENT_ID as string,
      ROBONEO_APP_KEY: '16440FE95FA2A86F',
    },
    beta: {
      ENV: 'beta',
      ROBONEO_ORIGIN: 'https://beta.roboneo.com',
      CLIENT_ID: process.env.NEXT_PUBLIC_REBONEO_CLIENT_ID as string,
      ROBONEO_APP_KEY: '16440FE95FA2A86F',
    },
    release: {
      ENV: 'release',
      ROBONEO_ORIGIN: 'https://roboneo.com',
      CLIENT_ID: process.env.NEXT_PUBLIC_REBONEO_CLIENT_ID as string,
      ROBONEO_APP_KEY: '90EA0E0834963405',
    },
  },
  currentEnv: process.env.NEXT_PUBLIC_ENV as Config['EnvId'],
});

type RoboneoNavigateTypes = {
  OriginId: RoboneoSiteDomain;
  Locale: Config['Locale'];
  Pathname: Config['Pathname'];
  Extra: {};
};

type RoboneoNavigateOptions = NavigateOptions<RoboneoNavigateTypes>;

/**
 * 按 originId 解析 RoboNeo 站点 origin，同域时使用当前 origin。
 * @param originId 目标站点域名标识
 */
function resolveRoboneoOrigin(originId: RoboneoSiteDomain): string {
  const env = getEnv();
  if (env.ENV === 'development') {
    return env.ROBONEO_ORIGIN;
  }
  if (typeof window !== 'undefined' && originId === getRoboneoSiteDomain()) {
    return window.location.origin;
  }
  if (originId === 'roboneo.cn') {
    return env.ROBONEO_ORIGIN.replace(/roboneo\.com/g, 'roboneo.cn');
  }
  return env.ROBONEO_ORIGIN.replace(/roboneo\.cn/g, 'roboneo.com');
}

/**
 * url 对象未传 originId 时，自动注入当前域名对应的 originId。
 * @param options navigate 参数
 */
function withDefaultOriginId(options: RoboneoNavigateOptions): RoboneoNavigateOptions {
  if (
    options.mode === 'url'
    && typeof options.url === 'object'
    && options.url
    && !options.url.originId
  ) {
    return {
      ...options,
      url: {
        ...options.url,
        originId: getNavigateOriginId(),
      },
    };
  }
  return options;
}

// 为什么要使用navigate()而不是window.location.href或者router.push()?
const { navigate: baseNavigate } = createNavigateAgent<RoboneoNavigateTypes>({
  // 可在这里修改query等等
  beforeResolution() {},
  originMap: {
    'roboneo.com': () => resolveRoboneoOrigin('roboneo.com'),
    'roboneo.cn': () => resolveRoboneoOrigin('roboneo.cn'),
  },
  beforeNavigation() {
    return true;
  },
});

/**
 * 包装 navigate：自动注入 originId，并将 onNavigate 读写转发到 baseNavigate。
 * NextPagesNavigator 会赋值 navigate.onNavigate；若仅挂在包装对象上而不转发，
 * mode: 'router' 仍会调用 baseNavigate 内部的空 onNavigate，导致侧栏 tab 点击无跳转。
 */
function roboneoNavigate(options: RoboneoNavigateOptions) {
  baseNavigate(withDefaultOriginId(options));
}

roboneoNavigate.options = baseNavigate.options;
roboneoNavigate.getResolvedUrl = (options: RoboneoNavigateOptions) => baseNavigate.getResolvedUrl(
  withDefaultOriginId(options),
);
Object.defineProperty(roboneoNavigate, 'onNavigate', {
  enumerable: true,
  configurable: true,
  get() {
    return baseNavigate.onNavigate;
  },
  set(handler: typeof baseNavigate.onNavigate) {
    baseNavigate.onNavigate = handler;
  },
});

export const navigate = roboneoNavigate as typeof baseNavigate;

export const statAgent = createStatAgent();

export const pageAgent = createPageAgent<{
  ProjectId: string;
  PageInfo: PageInfo;
  PageId: PageId;
}>({
  pageMap,
  getCurrentProjectId() {
    return '/--roboneo';
  },
});

export const LanguageCodeMap = {
  en: 'en',
  zh: 'zh-Hans',
};
